<div
  class="header-login__menu"
  [@slideInOut]="'slideFromTop'"
  *ngIf="isOpen"
  data-test="login-menu"
>
  <!-- User -->
  <div class="flex flex-col items-center" *ngIf="user?.fullname">
    <ng-container *ngIf="!isOrganizerMenu || (isUserFed && isOrganizerMenu)">
      <img class="header-login__image" [src]="userImageUrl" alt="" />
    </ng-container>
    <ng-container *ngIf="!isUserFed && isOrganizerMenu">
      <div class="header-login__image-container">
        <ng-container
          *ngIf="isPartnerModificationAuthorized; else partnerImage"
        >
          <a
            [href]="dashboardUrl"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="'a11y.organizer.edit.profile' | translate"
          >
            <img [src]="userImageUrl" alt="" />
            <span class="header-login__image-container__edit">
              <vtmn-play-icon
                [name]="iconType.Edit"
                [ariaLabel]="'a11y.organizer.edit.profile' | translate"
              ></vtmn-play-icon>
            </span>
          </a>
        </ng-container>
        <ng-template #partnerImage>
          <img [src]="userImageUrl" alt="" />
        </ng-template>
      </div>
    </ng-container>
    <p class="text-xl font-bold">{{ user.fullname }}</p>
    <p class="text-sm">{{ user.email }}</p>
  </div>

  <app-divider></app-divider>

  <!-- Menu list -->
  <ng-container *ngFor="let list of lists; let isFirst = first">
    <hr
      *ngIf="!isFirst"
      class="my-4 border-vtmn-play-content-brand-secondary"
    />

    <ul>
      <li
        *ngFor="let item of list; let isFirstItem = first"
        [class.pt-4]="!isFirstItem"
      >
        <ng-template #anchorContent>
          <span [innerHTML]="item.label"></span>

          <vtmn-play-icon
            *ngIf="item?.icon"
            [name]="item.icon"
            class="header-login__icon"
          ></vtmn-play-icon>
        </ng-template>

        <a
          *ngIf="item.routerLink"
          class="flex items-center"
          [routerLink]="item?.routerLink"
          [queryParams]="item?.queryParams"
          [target]="item?.queryParams?.openInNewTab ? '_blank' : '_self'"
        >
          <ng-template [ngTemplateOutlet]="anchorContent"></ng-template>
        </a>

        <a
          *ngIf="!item.routerLink"
          class="flex items-center"
          [href]="item.href"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ng-template [ngTemplateOutlet]="anchorContent"></ng-template>
        </a>
      </li>
    </ul>
  </ng-container>

  <app-divider></app-divider>

  <button
    app-vtmn-play-button
    type="button"
    [type]="ctaButtonType.Button"
    [variant]="vtmnPlayButtonVariant.SECONDARY"
    [shape]="vtmnPlayButtonShape.SQUARED"
    class="w-full"
    (click)="this.logout()"
  >
    {{ 'attendee.header.login_menu.button.disconnection' | translate }}
  </button>
</div>
